export const softwareList = ['AppFolio', 'Avail', 'Baselane', 'Buildium', 'Entrata', 'Freshbooks', 'Innago', 'Payrent', 'Property Manager Cloud', 'Property Matrix', 'Quickbooks', 'Real Page/OneSite/Property Ware', 'Rent Manager', 'Rentec Direct', 'RentRedi', 'ResMan', 'Rezedent', 'SimplifyEm', 'Resident Cloud', 'Resident Cube', 'TurboResident', 'Yardi', 'Yardi Breeze'];

/**
 * The built-in charge-export layouts, and the Company details values that switch each one on.
 *
 * The two have to be listed together because they do not match: a PM picks a label from
 * `softwareList`, while the export sends the backend a preset key. RealPage is listed as
 * "Real Page/OneSite/Property Ware", which matched nothing, so only Buildium was ever reachable
 * (LB-5998).
 */
export const chargeExportPresets = [{
  format: 'buildium',
  label: 'Buildium',
  software: ['Buildium']
}, {
  format: 'resman',
  label: 'ResMan',
  software: ['ResMan']
}, {
  format: 'realpage',
  label: 'RealPage',
  software: ['RealPage', 'Real Page/OneSite/Property Ware']
}];

/** The export preset a company's saved PMS switches on, or null when it switches on none. */
export const chargeExportPresetFor = propertyManagementSoftware => {
  var _chargeExportPresets$;
  const saved = (propertyManagementSoftware !== null && propertyManagementSoftware !== void 0 ? propertyManagementSoftware : '').trim().toLowerCase();
  if (!saved) return null;
  return (_chargeExportPresets$ = chargeExportPresets.find(preset => preset.software.some(name => name.toLowerCase() === saved))) !== null && _chargeExportPresets$ !== void 0 ? _chargeExportPresets$ : null;
};